import { useModel } from "bcms-react";
import ZellePage from "components/pages/ZellePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @function CaptureMabiZelleZelle
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description This component is used in the MABI23 "Zelle" capture group.
 */
export default function CaptureMabiZelleZelle(props) {
    const { branding } = useModel();
    const { options } = branding;
    const howIsZellePresented = options.present_zelle_abi22 ? options.present_zelle_abi22.toLowerCase() : undefined;

    if(howIsZellePresented === "checkfree") {
        const message = `This capture is not shown when ABI22 branding option "How is Zelle Presented?" is set to "Checkfree".`;
        return <CaptureNotShownView message={ message }/>;
    }

    return <ZellePage/>;
}